import { IndustryFilter } from "src/app/store/models/industry-page.model";

const topTen = {
  value: "top10",
  label: "Top 10",
};
const topFive = {
  value: "top5",
  label: "Top 5",
};
const total = {
  value: "total",
  label: "Total",
};
const average = {
  value: "average",
  label: "Average",
};

export const ChartRadioOptions = [topTen, topFive, total, average];

export const DefaultFilters: IndustryFilter = {
  marketCap: undefined,
  region: undefined,
  selectedLineItem: undefined,
  viewBy: ["values"],
  revision: "",
  currency: "",
  period: undefined,
  periodUserSettings: undefined,
  removeBlankRows: false,
};

export const KPI_TAB = "Core KPIs";
export const FINANCIAL_TAB = "Financials";
export const IndustryPageName = "INDUSTRY_PAGE";

export const INDUSTRY_PAGE_INFO = {
  kpis: {
    shortName: "kpis",
    fullName: "KPI's",
    pageNameForTracking: "INDUSTRY_KPI_PAGE",
  },
  revisionanalysis: {
    shortName: "revisionanalysis",
    fullName: "Revision Analysis",
    pageNameForTracking: "INDUSTRY_REVISION_ANALYSIS_PAGE",
  },
  surpriseanalysis: {
    shortName: "surpriseanalysis",
    fullName: "Surprise Analysis",
    pageNameForTracking: "INDUSTRY_SURPRISE_ANALYSIS_PAGE",
  },
  valuation: {
    shortName: "valuation",
    fullName: "Valuation",
    pageNameForTracking: "INDUSTRY_VALUATION_PAGE",
  },
};

export const ANALYTICS_FEATURE_NAME = {
  kpis: "INDUSTRY_KPIS",
  revisionanalysis: "INDUSTRY_REVISION_ANALYSIS",
  surpriseanalysis: "INDUSTRY_SURPRISE_ANALYSIS",
  valuation: "INDUSTRY_VALUATION",
};
